import { TFunction } from 'i18next';
import _ from 'lodash';
import { atom, selector } from 'recoil';
import { datasetProcessingAutomationMenuItems } from './datasetAutomation.default';
import {
  DatasetProcessingAutomationMenuItem,
  DatasetProcessingAutomationMenuItemId,
} from './datasetAutomation.types';

const getKey = (postfix: string) =>
  `warebee-dataset-processing-automation-${postfix}`;

export const datasetProcessingAutomationSelectedMenuItemId =
  atom<DatasetProcessingAutomationMenuItemId>({
    key: getKey('selected-menu-item-id'),
    default: 'dataset-processing-automation-menu-import-pipelines',
  });

export const datasetProcessingAutomationSelectedMenuItem =
  selector<DatasetProcessingAutomationMenuItem>({
    key: getKey('selected-step'),
    get: ({ get }) => {
      const menuId = get(datasetProcessingAutomationSelectedMenuItemId);
      return _.find(
        datasetProcessingAutomationMenuItems(_.identity as TFunction),
        s => s.id === menuId,
      );
    },
  });
